import React, { useState, useContext, useEffect } from "react";
import {
  MenuItem,
  TextField,
  InputAdornment,
  FormHelperText,
} from "@mui/material";
import { LoaderScreen } from "../../../../components/LoaderScreen";
import { ValOnlyTextWithSpace } from "../../../../../Validators/ValOnlyTextWithSpace";
import { ValOnlyNumber } from "../../../../../Validators/ValOnlyNumber";
import { ValPedidoCondiciones } from "./Validators/ValPedidoCondiciones";
import Swal from "sweetalert2";
import request from "../../../../../Helpers/API";
import { Context as PedidoContext } from "./DashPedidoMaquinariascreen";
import { useHistory } from "react-router-dom";
import { FormatMoney } from "../../../../../Helpers/FormatNumber";
import AccountBalanceIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";
import { ValSpecialCharacters } from "../../../../../Validators/ValSpecialCharacters";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Moneda } from "../../../../../Helpers/Moneda";
import SaveIcon from "@mui/icons-material/Save";
import SendIcon from "@mui/icons-material/Send";


export const DashPedidoCondicionesCredito = ({
  setScreen,
  setValue,
  setBottonguardar,
  tipoSolicitud,
  idclienteSolicitud
}) => {
  const { state } = useContext(PedidoContext);
  const history = useHistory();
  const [esquemas, setEsquemas] = useState([]);
  const [tipo_esquemas, setTipo_Esquemas] = useState([]);
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const [condiciones, setCondiciones] = useState({
    condiciones: "",
    observaciones: "",
    deposito: "",
    tasa: "",
    anticipo: "",
    plazo: "",
    tiempo_plazo: "",
    mhusajdf: "",
    gastos: 0,
    enganche: 0,
    bcondiciones: "",
    bobservaciones: "",
    bdeposito: "",
    btasa: "",
    banticipo: "",
    bplazo: "",
    btiempo_plazo: false,
    bmhusajdf: "",
    bgastos: "",
    benganche: "",
    tipo_tasa: "",
    tipo_esquema: "",
    moneda: "",
  });
  const [activeField, setActiveField] = useState(null);
  const [fecha, setFecha] = useState({ mes: "", año: "" });
  const [intereses, setIntereses] = useState({
    interes: 0,
    interes2: 0
  });





  useEffect(() => {
    const fechaActual = new Date();
    const mes = fechaActual.getMonth() + 1; // getMonth() devuelve el mes de 0 a 11
    const año = fechaActual.getFullYear();

    setFecha({ mes, año });
  }, []);



  const handleTextFieldFocus = (fieldName) => {
    setActiveField(fieldName); // Marcar el TextField como activo cuando se enfoca
  };

  const handleTextFieldBlur = () => {
    setActiveField(null); // Desactivar el TextField cuando pierde el foco
  };

  const onValidarCondicionesOperacion = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`SolicitudCredito/enviarCondicionesOperacion?folio=${state.folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });

        history.push("/DashClientes/solicitudcreditolistado", { idcliente: idclienteSolicitud });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
      });
  };

  const onChange = (prop, value, sbool, smensaje) => {
    const sinComas = value.replace(/,/g, "");
    setCondiciones({
      ...condiciones,
      [prop]: sinComas,
      ["b" + prop]: false,
      ["m" + prop]: "",
    });
  };
  const onChanged = (prop, value, sbool, smensaje) => {
    setCondiciones({
      ...condiciones,
      [prop]: value,
      ["b" + prop]: false,
      ["m" + prop]: "",
    });
  };
  const onFocus = (e) => {
    e.target.type = "number";
  };
  const onBlur = (e) => {
    e.target.type = "text";
    e.target.value = FormatMoney(Number(condiciones[e.target.name]));
  };
  const onBlurCondiciones = (e) => {
    e.target.type = "text";
    e.target.value = condiciones[e.target.name];
  };

  const onGuardar = () => {
    setLoader({ ...loader, mostrar: true });
    var result = ValPedidoCondiciones(condiciones);

    if (result.isValid === false) {
      setLoader({ ...loader, mostrar: false });
      Swal.fire(
        "PEDIDO DE MAQUINARIA",
        JSON.stringify(result.mensaje),
        "error"
      );
    } else if (
      condiciones.moneda === "" ||
      condiciones.moneda == undefined ||
      condiciones.moneda === null
    ) {
      Swal.fire({
        title: "PEDIDO DE MAQUINARIA",
        text: "Seleccione una moneda",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      setLoader({ ...loader, mostrar: false });
    } else {
      result.post.folio = state.folio;
      result.post.taza =
        // state.tipo_solicitud === "J" ? condiciones.tipo_tasa : condiciones.tasa;
        state.tipo_solicitud === "J" ? condiciones.tasa : condiciones.tasa;
      result.post.plazo =
        // state.tipo_solicitud === "J"
        //   ? condiciones.tipo_esquema
        //   : state.tipo_solicitud === "C"
        //     ? "dias" : result.post.plazo;
        state.tipo_solicitud === "J"
          ? result.post.plazo
          : state.tipo_solicitud === "C"
            ? "dias" : result.post.plazo;
      result.post.mhusajdf = state.tipo_solicitud === "J" ? "JDFM" : "MHUSA";
      result.post.moneda = condiciones.moneda;
      if (state.tipo_solicitud === "C") {
        result.post.plazo = "D";
      }
      // result.post.folio = state.folio;
      // result.post.taza = condiciones.tasa;
      // result.post.mhusajdf = state.tipo_solicitud === "J" ? "JDFM" : "MHUSA";
      // result.post.moneda = condiciones.moneda;

      request
        .post("PedidoCondicionesCredito", result.post)
        .then(async () => {
          setScreen(3);
          setValue(3);
          if (tipoSolicitud === "C") {
            onValidarCondicionesOperacion();
          } else {
            setLoader({ ...loader, mostrar: false });
            await Swal.fire(
              "PEDIDO DE MAQUINARIA",
              "Datos guardados con exito",
              "success"
            );
          }
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
        });
    }
  };

  useEffect(() => {
    if (
      state.folio === undefined ||
      state.folio === null ||
      state.folio.length !== 13
    ) {
      history.push("/DashClientes/solicitudcreditoGenerar");
      return;
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(`PedidoCondicionesCredito/ListadoCondiciones?folio=${state.folio}`)
      .then((result) => {

        setCondiciones({
          ...condiciones,
          condiciones: result.condiciones.condiciones,
          observaciones: result.condiciones.observaciones,
          deposito: result.condiciones.deposito,
          tasa:
            result.condiciones.taza !== undefined &&
              result.condiciones.taza !== null &&
              result.condiciones.taza !== 0
              ? result.condiciones.taza
              : result.interes.interes,
          mhusajdf: result.condiciones.mhusajdf,
          anticipo: result.condiciones.anticipo,
          moneda:
            result.condiciones.moneda !== undefined &&
              result.condiciones.moneda !== null &&
              result.condiciones.moneda !== ""
              ? result.condiciones.moneda
              : "MXN",
          // gastos: result.gastos,
          plazo: result.condiciones.plazo,
          tiempo_plazo: result.condiciones.tiempo_plazo,
          // enganche: result.enganche,
          tipo_tasa: result.condiciones.tipo_tasa,
          tipo_esquema: result.condiciones.tipo_esquema,
        });
        setIntereses({
          ...intereses,
          interes: result.interes.interes,
          interes2: result.interes.interes2
        })
        var deposito = document.getElementById("deposito");
        if (deposito !== undefined && deposito !== null)
          deposito.value = FormatMoney(result.condiciones.deposito);
        var tiempo_plazo = document.getElementById("tiempo_plazo");
        if (tiempo_plazo !== undefined && tiempo_plazo !== null)
          tiempo_plazo.value = FormatMoney(result.condiciones.tiempo_plazo);

        if (state.tipo_solicitud === "O" || state.tipo_solicitud === "J") {
          var tasa = document.getElementById("tasa");
          if (tasa !== undefined && tasa !== null && result.condiciones.taza === 0)
            tasa.value = FormatMoney(result.interes.interes)
          else (
            tasa.value = FormatMoney(result.condiciones.taza)
          )
        }


        var anticipo = document.getElementById("anticipo");
        if (anticipo !== undefined && anticipo !== null)
          anticipo.value = FormatMoney(result.condiciones.anticipo);

        // request
        //   .get("TasasJDF/Obtener_tasas")
        //   .then((resulttasa) => {
        //     setLoader({ ...loader, mostrar: false });
        //     setEsquemas(resulttasa);
        //   })
        //   .catch((errortasa) => {
        //     setLoader({ ...loader, mostrar: false });
        //     Swal.fire(
        //       "PEDIDO CONDICIONES DEL CREDITO",
        //       JSON.stringify(errortasa),
        //       "error"
        //     );
        //   });

        if (state.tipo_solicitud === "J") {
          request
            .get("TasasJDF/Obtener_tasas")
            .then((resulttasa) => {
              setLoader({ ...loader, mostrar: false });
              setEsquemas(resulttasa);
            })
            .catch((errortasa) => {
              setLoader({ ...loader, mostrar: false });
              Swal.fire(
                "PEDIDO CONDICIONES DEL CREDITO",
                JSON.stringify(errortasa),
                "error"
              );
            });
        } else {
          setLoader({ ...loader, mostrar: false });
        }
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
      });
  }, []);

  useEffect(() => {
    let nuevaTasa;

    if (intereses.interes !== 0 && intereses.interes2 !== 0) {
      if (
        (condiciones.plazo === "meses" && condiciones.tiempo_plazo > 6) ||
        (condiciones.plazo === "dias" && condiciones.tiempo_plazo >= 180) ||
        (condiciones.plazo === "años" && condiciones.tiempo_plazo >= 1)
      ) {
        nuevaTasa = intereses.interes2;
      } else {
        nuevaTasa = intereses.interes;
      }

      setCondiciones({
        ...condiciones,
        tasa: nuevaTasa
      });

      if (state.tipo_solicitud === "O" || state.tipo_solicitud === "J") {
        const tasa = document.getElementById("tasa");
        tasa.value = FormatMoney(nuevaTasa);
      }
    }

  }, [condiciones.plazo, condiciones.tiempo_plazo]);

  const onActualizarInteres = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`PedidoCondicionesCredito/ActualizarTasa?folio=${state.folio}&ejercicio=${fecha.año}&periodo=${fecha.mes}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setCondiciones({
          ...condiciones,
          tasa: result.interes
        });

        var tasa = document.getElementById("tasa");
        tasa.value = FormatMoney(result.interes)
      })
      .catch((errortasa) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "PEDIDO CONDICIONES DEL CREDITO",
          JSON.stringify(errortasa),
          "error"
        );
      });
  }

  useEffect(() => {
    setBottonguardar(
      tipoSolicitud === "C" ? (
        <div
          className="pedido-maquinaria-container-footer-guardar"
          onClick={() => onGuardar()}
        >
          Validar Condiciones <SendIcon />
        </div>
      ) : (
        <div
          onClick={() => onGuardar()}
          className="pedido-maquinaria-container-footer-guardar"
        >
          <SaveIcon /> GUARDAR Y CONTINUAR
        </div>
      )
    );
  }, [condiciones]);
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    if (state.tipo_solicitud === "J") {
      request
        .get(
          `TasasJDF/Obtener_tasas_valores?idtasa=${Number(
            condiciones.tipo_tasa
          )}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setTipo_Esquemas(result);
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("PEDIDO CONDICIONES", JSON.stringify(error), "error");
        });
    } else {
      setLoader({ ...loader, mostrar: false });
    }
  }, [condiciones.tipo_tasa]);
  return (
    <div className="pedido_condiciones_Credito">
      <LoaderScreen loader={loader} />

      <div className="pedido-maquinaria-condiciones-condiciones">
        <TextField
          fullWidth
          size="small"
          label="Condiciones para Operación de Venta"
          // className="cel-1"
          multiline
          rows={2}
          type="text"
          error={condiciones.bcondiciones}
          onChange={({ target }) => {
            ValSpecialCharacters(
              "condiciones",
              target.value,
              onChanged,
              true,
              500
            );
          }}
          onFocus={() => handleTextFieldFocus("condiciones")} // Manejar el foco del TextField
          onBlur={handleTextFieldBlur} // Manejar la pérdida de foco del TextField
          value={condiciones.condiciones}
          InputProps={{
            startAdornment: <InputAdornment position="start"></InputAdornment>,
          }}
        />
        {activeField === "condiciones" && (
          <FormHelperText className="caracteres-especiales">
            {"Puedes usar caracteres especiales como: $, #, . , y ñ."}
          </FormHelperText>
        )}
      </div>
      <div className="pedido-maquinaria-condiciones-observaciones">
        <TextField
          fullWidth
          size="small"
          label="Observaciones"
          variant="outlined"
          // className="cel-2"
          multiline
          rows={2}
          type="text"
          error={condiciones.bobservaciones}
          onChange={({ target }) => {
            ValSpecialCharacters(
              "observaciones",
              target.value,
              onChanged,
              true,
              500
            );
          }}
          onFocus={() => handleTextFieldFocus("observaciones")} // Manejar el foco del TextField
          onBlur={handleTextFieldBlur} // Manejar la pérdida de foco del TextField
          value={condiciones.observaciones}
          InputProps={{
            startAdornment: <InputAdornment position="start"></InputAdornment>,
          }}
        />
        {activeField === "observaciones" && (
          <FormHelperText className="caracteres-especiales">
            {"Puedes usar caracteres especiales como: $, #, . , y ñ."}
          </FormHelperText>
        )}
      </div>
      <TextField
        fullWidth
        size="small"
        label="Deposito Realizado"
        variant="outlined"
        className="cel-3"
        type="text"
        name="deposito"
        id="deposito"
        error={condiciones.bdeposito}
        onKeyUp={(input) => Moneda(input.target)}
        onChange={({ target }) => {
          ValOnlyNumber("deposito", target.value, onChange, true, 10);
        }}
        // onChange={({ target }) =>
        //   setCondiciones({ ...condiciones, deposito: target.value })
        // }
        // value={condiciones.deposito}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <AccountBalanceIcon />
            </InputAdornment>
          ),
        }}
        inputProps={{
          style: { textAlign: "right" },
        }}
      />
      <div className="cel-4">
        <TextField
          fullWidth
          size="small"
          label="Anticipo Total"
          variant="outlined"
          // className="cel-4"
          type="text"
          error={condiciones.banticipo}
          onChange={({ target }) => {
            ValOnlyNumber("anticipo", target.value, onChange, true, 10);
          }}
          sx={{ paddingRight: "5px" }}
          // onChange={({ target }) => {
          //   setCondiciones({ ...condiciones, anticipo: target.value });
          // }}
          // value={condiciones.anticipo}
          onKeyUp={(input) => Moneda(input.target)}
          name="anticipo"
          id="anticipo"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <AccountBalanceIcon />
              </InputAdornment>
            ),
          }}
          inputProps={{
            style: { textAlign: "right" },
          }}
        />
        <TextField
          fullWidth
          size="small"
          label="Moneda"
          variant="outlined"
          // className="cel-11"
          select
          sx={{
            "& .MuiInputBase-root": {
              height: "35px", // Cambia el valor para ajustar la altura
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <AccountBalanceIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
          type="text"
          // error={condiciones.moneda}
          onChange={({ target }) => {
            setCondiciones({ ...condiciones, moneda: target.value });
          }}
          value={condiciones.moneda}
        >
          <MenuItem value={"MXN"}>PESOS</MenuItem>
          <MenuItem value={"USD"}>DOLARES</MenuItem>
        </TextField>
      </div>
      {/* {state.tipo_solicitud === "J" && (
        <TextField
          fullWidth
          size="small"
          label="Tipo Tasa"
          variant="outlined"
          select
          type="text"
          className="cel-7"
          onChange={({ target }) => {
            setCondiciones({ ...condiciones, tipo_tasa: target.value });
          }}
          value={condiciones.tipo_tasa}
        >
          {esquemas.map((item) => (
            <MenuItem value={item.id}>{item.descripcion}</MenuItem>
          ))}
        </TextField>
      )} */}
      {/* {state.tipo_solicitud === "J" && (
        <TextField
          fullWidth
          size="small"
          label="Plazo"
          variant="outlined"
          select
          type="text"
          className="cel-8"
          onChange={({ target }) => {
            setCondiciones({ ...condiciones, tipo_esquema: target.value });
          }}
          value={condiciones.tipo_esquema}
        >
          {tipo_esquemas.map((item) => (
            <MenuItem value={item.id}>{item.descripcion}</MenuItem>
          ))}
        </TextField>
      )} */}
      {/* {state.tipo_solicitud !== "J" && (
        <div className="taza-actualizar-container">
          <TextField
            fullWidth
            disabled={state.tipo_solicitud === "C" ? true : false}
            size="small"
            label="Tasa Anual Aplicada"
            variant="outlined"
            className="cell-5"
            type="text"
            name="tasa"
            id="tasa"
            error={condiciones.btasa}
            onKeyUp={(input) => Moneda(input.target)}
            onChange={({ target }) => {
              ValOnlyNumber("tasa", target.value, onChange, true, 8);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PercentIcon />
                </InputAdornment>
              ),
            }}
            inputProps={{
              style: { textAlign: "right" },
            }}
          />
          <button className="cell-6" onClick={() => onActualizarInteres()}>Actualizar</button>
        </div>
      )} */}
      {/* {state.tipo_solicitud !== "J" && (
        <div className="cel-6">
          <TextField
            fullWidth
            disabled={state.tipo_solicitud === "C" ? true : false}
            size="small"
            label="Plazo"
            variant="outlined"
            select
            type="text"
            className="cel-plazo"
            onChange={({ target }) => {
              setCondiciones({ ...condiciones, plazo: target.value });
            }}
            value={condiciones.plazo}
            sx={{
              "& .MuiInputBase-root": {
                height: "35px", // Cambia el valor para ajustar la altura
              },
            }}
          >
            <MenuItem value="dias">DIAS</MenuItem>
            <MenuItem value="meses">MESES</MenuItem>
            <MenuItem value="años">AÑOS</MenuItem>
          </TextField>

          <TextField
            fullWidth
            disabled={state.tipo_solicitud === "C" ? true : false}
            size="small"
            label="Tiempo"
            variant="outlined"
            type="number"
            error={condiciones.btiempo_plazo}
            onChange={({ target }) => {
              ValOnlyNumber("tiempo_plazo", target.value, onChange, true, 10);
            }}
            onFocus={onFocus}
            onBlur={onBlurCondiciones}
            name="tiempo_plazo"
            id="tiempo_plazo"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccessTimeIcon />
                </InputAdornment>
              ),
            }}
            inputProps={{
              style: { textAlign: "right" },
              max: 10,
            }}
          />
        </div>
      )} */}
      <div className="taza-actualizar-container">
        <TextField
          fullWidth
          disabled={state.tipo_solicitud === "C" ? true : true}
          size="small"
          label="Tasa Anual Aplicada"
          variant="outlined"
          className="cell-5"
          type="text"
          name="tasa"
          id="tasa"
          error={condiciones.btasa}
          onKeyUp={(input) => Moneda(input.target)}
          onChange={({ target }) => {
            ValOnlyNumber("tasa", target.value, onChange, true, 8);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PercentIcon />
              </InputAdornment>
            ),
          }}
          inputProps={{
            style: { textAlign: "right" },
          }}
        />
        <button
          className="cell-6"
          onClick={() => onActualizarInteres()}
        >
          Actualizar
        </button>
      </div>
      <div className="cel-6">
        <TextField
          fullWidth
          disabled={state.tipo_solicitud === "C" ? true : false}
          size="small"
          label="Plazo"
          variant="outlined"
          select
          type="text"
          className="cel-plazo"
          onChange={({ target }) => {
            setCondiciones({ ...condiciones, plazo: target.value });
          }}
          value={condiciones.plazo}
          sx={{
            "& .MuiInputBase-root": {
              height: "35px", // Cambia el valor para ajustar la altura
            },
          }}
        >
          <MenuItem value="dias">DIAS</MenuItem>
          <MenuItem value="meses">MESES</MenuItem>
          <MenuItem value="años">AÑOS</MenuItem>
        </TextField>

        <TextField
          fullWidth
          disabled={state.tipo_solicitud === "C" ? true : false}
          size="small"
          label="Tiempo"
          variant="outlined"
          type="number"
          error={condiciones.btiempo_plazo}
          onChange={({ target }) => {
            ValOnlyNumber("tiempo_plazo", target.value, onChange, true, 10);
          }}
          onFocus={onFocus}
          onBlur={onBlurCondiciones}
          name="tiempo_plazo"
          id="tiempo_plazo"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <AccessTimeIcon />
              </InputAdornment>
            ),
          }}
          inputProps={{
            style: { textAlign: "right" },
            max: 10,
          }}
        />
      </div>
    </div>
  );
};
